<template>
    <div
        class="absolute inset-0 animate-pulse rounded-lg -mx-1 -my-0.5 bg-gray-50"
        :class="isLoading ? 'block' : 'hidden'"
    />
</template>

<script>
export default {
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
